export const PHONE_PATTERN = '^[+][1-9]{3}[0-9]{7,10}$';

// Allow all Unicode letters plus combining marks, spaces, dot, hyphen, and apostrophes (straight and curly)
export const NAME_PATTERN = /^[\p{L}\p{M} .'-’]+$/u;

export const NUMBERS_ONLY = '^[0-9]+$';

export const DECIMAL_NUMBERS = '^\\d+([.,]\\d+)?$';
